'use client';

import { Box, Typography } from '@mui/material';
import { useRoundupPicksSummary } from '../../RoundupPicksSummaryContext';

export const RoundupPicksSummary = () => {
  const picks = useRoundupPicksSummary();

  if (picks.length === 0) {
    return null;
  }

  return (
    // Overrides an ancestor's `& * { display: inline }` that would otherwise collapse this list.
    <Box component="ul" data-testid="roundup-picks-summary" sx={{ display: 'block' }}>
      {picks.map(pick => (
        <Box
          component="li"
          key={pick.id}
          sx={{
            display: 'list-item',
            '&:not(:first-of-type)': {
              marginTop: 2,
            },
          }}
        >
          <Typography component="p" variant="body">
            <strong>{pick.name}</strong>: Our pick for{' '}
            {pick.ourPickFor.charAt(0).toLowerCase() + pick.ourPickFor.slice(1)}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};
